import { render, staticRenderFns } from "./PxCard.vue?vue&type=template&id=5c07ecce&scoped=true&lang=pug&"
import script from "./PxCard.vue?vue&type=script&lang=js&"
export * from "./PxCard.vue?vue&type=script&lang=js&"
import style0 from "./PxCard.vue?vue&type=style&index=0&id=5c07ecce&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c07ecce",
  null
  
)

export default component.exports